/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        
        $(".product-slider-cnt").owlCarousel({
            loop:true,
            margin:0,
            nav:true,
            dots:true,
            //autoplay: true,
            //autoplayTimeout : 5000,
            //autoplayHoverPause: true,
            //autoplaySpeed: 1000,
            responsiveClass:true,
            animateIn: 'slideInRight',
            animateOut: 'slideOutLeft',
            navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
            dotsContainer: '#navs .dots',
            navContainer: '#navs .navs',
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:2
                },
                1000:{
                    items:4
                }
            }
        });

        $('.newsletter-cnt .eqh').matchHeight();

        $('.catalog-wrapper .catalog-item .catalog-item-cnt').matchHeight({
          byRow: true
        }); 

        

        $(function() {
            $('.banner-left-wrap').matchHeight({
                target: $('.banner-right-wrap')
            });
        });

        //Affix
        var main_header = $('header#art-head');
        var art_header_height = $('header#art-head').outerHeight();
        
        main_header.affix({
          offset: {
            top: art_header_height
          }
        }); 

        

        //Megamenu

        $(document).on('click', '.yamm .dropdown-menu', function(e) {
           e.stopPropagation();
        });


        //Masonry
        var isActive = false;
        var masonryOptions = {
              itemSelector: '.col-sm-3',
              columnWidth: '.col-sm-3',
              percentPosition: true,
              originLeft: false
        };
        var $grid = $('.yamm-fw .grid');

        function viewport() {
          var e = window, a = 'inner';
          if (!('innerWidth' in window )) {
              a = 'client';
              e = document.documentElement || document.body;
          }
          return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }


        function artMasonry() {
        
          $('.yamm-fw').removeClass('open');
          $('.navbar-collapse').collapse('hide');
          
          if (viewport().width > 768) {           
            $('.yamm-fw').addClass('open');              
            $grid.masonry( masonryOptions );
            $('.yamm-fw').removeClass('open');
            
            isActive = true;
          } else {
            if ( isActive ) {
              $grid.masonry( 'destroy' );
              $grid.find('.col-sm-3').removeAttr('style');
              isActive = false;
            }
          }
        }

        //Accordion
        function artAccordion() {
          if (viewport().width > 768) {
            $(document).find('.yamm-fw .grid .col-sm-3').each(function(){
              $(this).find('.action i').attr('href','').attr('data-toggle','').removeClass('collapsed');
              $(this).find('ul').removeAttr('class');
            }); 
          } else {               
            var panel_counter = 0;
            $(document).find('.yamm-fw .grid .col-sm-3').each(function(){
              panel_counter++;
              var panel_id = panel_counter;
              $(this).find('.action i').attr('href','#collapse-' +panel_id).attr('data-toggle','collapse').addClass('collapsed');
              $(this).find('ul').attr('id', 'collapse-'+panel_id).addClass('panel-collapse collapse');
            });
          }
        }

        artAccordion();
        artMasonry();
        

        //Sidebar Categories accordion
        function sidebarCategoryAccordion() {
          if (viewport().width < 768) {
            var panel_counter = 0;
            $(document).find('#sidebar-accordion > .panel').each(function(){
              panel_counter++;
              var panel_id = panel_counter;
              $(this).find('.panel-heading a').attr('data-toggle','collapse');
              $(this).find('.panel-collapse').addClass('collapse');
            });
          } else {
            $(document).find('#sidebar-accordion > .panel').each(function(){
              $(this).find('.panel-heading a').attr('data-toggle','').removeClass('collapsed');
              $(this).find('.panel-collapse').removeClass('collapse in').css('height','auto');
            });
          }
        }

        //Sidebar filter accordion
        function sidebarFilterAccordion() {
          if (viewport().width < 768) {
            var panel_counter = 0;
            $(document).find('#filter-accordion .panel').each(function(){
              panel_counter++;
              var panel_id = panel_counter;
              $(this).find('.panel-heading a').attr('href','#collapseAttr-'+panel_id).attr('data-toggle','collapse');
              $(this).find('.panel-collapse').attr('id', 'collapseAttr-'+panel_id).addClass('collapse');
            });
          } else {
            $(document).find('#filter-accordion .panel').each(function(){
              $(this).find('.panel-heading a').attr('href','').attr('data-toggle','').removeClass('collapsed');
              $(this).find('.panel-collapse').attr('id', '').removeClass('collapse in').css('height','auto');
            });
          }
        }

        sidebarFilterAccordion();
        sidebarCategoryAccordion();

        //Resize
        $(window).on('resize', function(){ 
          artAccordion();
          artMasonry();
          sidebarFilterAccordion();
          sidebarCategoryAccordion();
        });  


        $(".kpc-inner").owlCarousel({
            loop:true,
            margin:0,
            nav:true,
            dots:false,
            //autoplay: true,
            //autoplayTimeout : 5000,
            //autoplayHoverPause: true,
            //autoplaySpeed: 1000,
            responsiveClass:true,
            animateIn: 'slideInRight',
            animateOut: 'slideOutLeft',
            navText: ['<span class="nav-left-bg"></span>','<span class="nav-right-bg"></span>'],
            dotsContainer: '#navs .dots',
            navContainer: '#navs .navs',
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:2
                },
                1000:{
                    items:4
                }
            }
        });

        //Product Image Slider

        var prod_thumb_slider = $(".product-image-slider"),
            prod_slider_settings = {
              animateOut: 'fadeOutLeft',
              //animateIn: 'slideInRight',
              items:1,
              nav:false,
              //autoHeight: true,
              dots:false,
              center: true,
              video:true,
              URLhashListener:true,
              callbacks: true,
              responsive: true,
              //videoHeight: 500, // Default false; Type: Boolean/Number
              startPosition: 'URLHash',
        };
     
        prod_thumb_slider.owlCarousel( prod_slider_settings );

        //Checkout
          //Firm Check
          $('#inputFirmCheck').click(function() {
              console.log('click');
              $(".form-section-wrapp").slideToggle(this.checked);
          });
          //Login
          $('#inputLoginCheck').click(function() {
              console.log('click');
              $(".form-section-login-wrapp").slideToggle(this.checked);
          });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
